export const ICON_SIZES = {
    // sm: 18,
    // md: 22,
    // lg: 28,
  desktop: {
    sm: 18,
    md: 22,
    lg: 28,
  },

  mobile: {
    sm: 16,
    md: 20,
    lg: 26,
  },
};
export const LOGO_SIZES = {
  desktop: {
    sm: 28,
    md: 40,
    lg: 48,
  },

  mobile: {
    sm: 22,
    md: 36,
    lg: 45,
  },
};